/* Bokja wishlist — storage adapter + UI glue.
   The adapter is the ONLY thing that talks to the storage backend, so the backend can be swapped
   (localStorage v1 → Swym Wishlist Plus later) without touching any UI. Loaded globally from
   snippets/scripts.liquid. Items are { id: <productId>, variant: <variantId|null>, handle, at }.

   UI contract (so the same glue serves the PDP, cards and the drawer):
   - A save control is any element with [data-bokja-save] carrying data-product-id (+ optional
     data-variant-id / data-product-handle). Clicking it toggles; .is-saved + aria-pressed reflect state.
   - window.BokjaWishlist exposes add/remove/toggle/has/getAll/getIds/count/subscribe.
   - document fires bokja:wishlist:change ({items,count}) on every change and bokja:wishlist:added
     ({item,loggedIn}) when an item is added (used to nudge guests to sign in for cross-device sync). */
(function () {
  if (window.BokjaWishlist) return;
  var KEY = 'bokja_wishlist';
  var subs = [];

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    notify();
  }
  function notify() {
    var list = read();
    subs.forEach(function (fn) { try { fn(list); } catch (e) {} });
    document.dispatchEvent(new CustomEvent('bokja:wishlist:change', { detail: { items: list, count: list.length } }));
  }
  function idOf(x) { return String(x && typeof x === 'object' ? x.id : x); }

  var API = {
    loggedIn: !!window.__bokjaCustomer,
    getAll: function () { return read(); },
    getIds: function () { return read().map(function (i) { return i.id; }); },
    count: function () { return read().length; },
    has: function (x) { var id = idOf(x); return read().some(function (i) { return String(i.id) === id; }); },
    add: function (item) {
      if (!item || item.id == null) return false;
      var list = read();
      var id = idOf(item);
      if (list.some(function (i) { return String(i.id) === id; })) return false;
      list.push({ id: item.id, variant: item.variant || null, handle: item.handle || null, at: Date.now() });
      write(list);
      document.dispatchEvent(new CustomEvent('bokja:wishlist:added', { detail: { item: item, loggedIn: API.loggedIn } }));
      return true;
    },
    remove: function (x) {
      var id = idOf(x);
      write(read().filter(function (i) { return String(i.id) !== id; }));
      return true;
    },
    toggle: function (item) {
      if (API.has(item)) { API.remove(item); return false; }
      API.add(item); return true;
    },
    subscribe: function (fn) {
      if (typeof fn !== 'function') return function () {};
      subs.push(fn); fn(read());
      return function () { subs = subs.filter(function (s) { return s !== fn; }); };
    },
  };

  window.addEventListener('storage', function (e) { if (e.key === KEY) notify(); });
  window.BokjaWishlist = API;

  /* ---- UI glue: reflect state onto every [data-bokja-save] control, and toggle on click ---- */
  function paint(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var saved = API.has(id);
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('[data-bokja-save-label]');
    if (label) {
      var on = btn.getAttribute('data-label-saved');
      var off = btn.getAttribute('data-label-save');
      if (on && off) label.textContent = saved ? on : off;
    }
  }
  function paintAll() {
    document.querySelectorAll('[data-bokja-save]').forEach(paint);
  }

  // Freshest variant id: prefer the PDP form's live variant input (respects the variant/size
  // picker), else the control's own data-variant-id.
  function variantFor(btn) {
    var form = btn.closest('.bokja-product-details, product-form-component, form');
    var input = form && form.querySelector('[ref="variantId"], input[name="id"]');
    return (input && input.value) || btn.getAttribute('data-variant-id') || null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bokja-save]');
    if (!btn) return;
    e.preventDefault();
    API.toggle({
      id: btn.getAttribute('data-product-id'),
      variant: variantFor(btn),
      handle: btn.getAttribute('data-product-handle'),
    });
    paint(btn);
  });

  document.addEventListener('bokja:wishlist:change', paintAll);

  // Guest nudge: a quiet toast inviting sign-in so the list follows them across devices. Shown only
  // when a guest ADDS (never on remove), at most once per page. localStorage tracking already
  // happened, so dismissing loses nothing.
  var nudged = false;
  document.addEventListener('bokja:wishlist:added', function (e) {
    if (API.loggedIn || nudged) return;
    nudged = true;
    showToast();
  });
  function showToast() {
    if (document.querySelector('.bokja-wishlist-toast')) return;
    var url = window.__bokjaAccountUrl || '/account';
    var t = document.createElement('div');
    t.className = 'bokja-wishlist-toast';
    t.setAttribute('role', 'status');
    t.innerHTML =
      '<span class="bokja-wishlist-toast__text">' + (window.__bokjaWishlistStrings && window.__bokjaWishlistStrings.nudge || 'Saved to your list.') + '</span>' +
      '<a class="bokja-wishlist-toast__link" href="' + url + '">' + (window.__bokjaWishlistStrings && window.__bokjaWishlistStrings.signIn || 'Sign in to keep it') + '</a>' +
      '<button type="button" class="bokja-wishlist-toast__close" aria-label="Close">&times;</button>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    var hide = function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); };
    t.querySelector('.bokja-wishlist-toast__close').addEventListener('click', hide);
    setTimeout(hide, 6000);
  }

  if (document.readyState !== 'loading') paintAll();
  else document.addEventListener('DOMContentLoaded', paintAll);
})();
